import './timeline.scss';

import { A11y, Navigation, Pagination } from 'swiper/modules';

class Timeline {
    constructor ($element, options) {
        const defaults = {
            initAttr: 'data-timeline'
        };

        this.settings = Object.assign({}, defaults, options);
        this.$timeline = $element;
        this.$timelineSlider = this.$timeline.querySelector('[' + this.settings.initAttr + '="slider"]');
        this.$$timelineSlides = this.$timeline.querySelectorAll('[' + this.settings.initAttr + '="slide"]');
        this.$$paginationBullets = null;
        this.$activeSlide = null;

        this.activeSlideIndex = 0;
        this.timelineSlider = null;
        this.yearContainer = null;
        this.sliderActive = false;

        if (this.$$timelineSlides.length > 1) {
            import(
                /* webpackChunkName: "slider/slider.js" */
                './../../components/slider/slider').then(({ Slider }) => {
                this.Slider = Slider;
                this.initialize();
            });
        }
    }

    initialize () {
        this.checkSize();
    }

    checkSize () {
        if (this.$$timelineSlides.length > 1) {
            if (this.sliderActive === false) {
                this.initSlider();
            }
        } else {
            if (this.sliderActive === true) {
                this.destroySlider();
                this.sliderActive = false;
            }
        }
    }

    moveMobilePagination () {
        for (let index = 0; index < this.$$paginationBullets.length; index++) {
            this.$$paginationBullets[index].style.setProperty('--multiplicator', this.activeSlideIndex * -1);
        }

        if (this.activeSlideIndex === 0) {
            this.$timelineSlider.classList.add('timeline__slider--first-active');
        } else if (this.activeSlideIndex === this.$$timelineSlides.length - 1) {
            this.$timelineSlider.classList.add('timeline__slider--last-active');
        } else {
            this.$timelineSlider.classList.remove('timeline__slider--last-active');
            this.$timelineSlider.classList.remove('timeline__slider--first-active');
        }
    }

    generatePagination () {
        this.$$paginationBullets = document.querySelectorAll('.swiper-pagination-bullet');

        for (let index = 0; index < this.$$paginationBullets.length; index++) {
            const startYear = this.$$timelineSlides[index].getAttribute('data-timeline-startyear');
            const endYear = this.$$timelineSlides[index].getAttribute('data-timeline-endyear');

            this.$$paginationBullets[index].innerHTML = startYear;

            if (endYear) {
                this.$$paginationBullets[index].innerHTML += `<span> - ${endYear}</span>`;
            }
        }

        this.moveMobilePagination();
    }

    setYear () {
        const activeYear = this.$activeSlide.getAttribute('data-timeline-startyear');
        const activeEndYear = this.$activeSlide.getAttribute('data-timeline-endyear');

        if (this.yearContainer !== null) {
            this.yearContainer.innerHTML = activeYear;
        } else {
            this.yearContainer = document.createElement('div');
            this.yearContainer.classList.add('timeline__year');
            this.yearContainer.innerHTML = activeYear;
            this.$timelineSlider.prepend(this.yearContainer);
        }

        if (activeEndYear) {
            this.yearContainer.innerHTML += `<span> - ${activeEndYear}</span>`;
        }
    }

    initSlider () {
        this.timelineSlider = new this.Slider(this.$timelineSlider, {
            modules: [A11y, Navigation, Pagination],
            calculateHeight: false,
            speed: 500,
            slidesPerView: 'auto',
            slidesPerGroup: 1,
            centeredSlides: false,
            centeredSlidesBounds: true,
            initAttr: this.settings.initAttr,
            indicators: true,
            simulateTouch: false,
            onInit: ($current, currentIndex, activeIndex) => {
                this.activeSlideIndex = activeIndex;
                this.$activeSlide = currentIndex;
                this.setYear();
            },
            onSlideChange: (slider, $current, currentIndex, activeIndex) => {
                this.activeSlideIndex = activeIndex;
                this.$activeSlide = currentIndex;
                this.setYear();
                this.moveMobilePagination();
            }
        });

        setTimeout(() => {
            this.generatePagination();
        }, 300);

        this.sliderActive = true;
    }

    destroySlider () {
        if (typeof this.timelineSlider !== 'undefined' && this.timelineSlider !== null) {
            this.timelineSlider.destroy();
        }
    }
}

export { Timeline };

window.addEventListener('content.loaded', (e) => {
    const eventDetails = e.detail;
    const $context = eventDetails.$context;

    if ($context) {
        const $$timeline = $context.querySelectorAll('[data-timeline="root"]');
        for (let i = 0; i < $$timeline.length; i++) {
            const $timeline = $$timeline[i];

            const TimelineAPI = new Timeline($timeline);
            $timeline.API = TimelineAPI;
        }
    }
});
